import { ThemeInterface } from "@styles/theme";

export const styles = (theme: ThemeInterface) => ({
	appDialog: {
		// background: 'red',
	},
});

export default styles;
